module.exports = __webpack_public_path__ + "static/media/noselect.395fdaf3.webp";